import { useNavigate, useParams } from 'react-router-dom';
import ViticulturaForm from './ViticulturaForm';
import VinificacionForm from './VinificacionForm';
import EmbotelladoForm from './EmbotelladoForm';
import { ReactComponent as ViticulturaIcon } from '../../assets/icons/ViticulturaIcon.svg';
import { ReactComponent as VinificacionIcon } from '../../assets/icons/VinificacionIcon.svg';
import { ReactComponent as EmbotelladoIcon } from '../../assets/icons/EmbotelladoIcon.svg';

const FORMULARIOS = {
    viticultura: ViticulturaForm,
    vinificacion: VinificacionForm,
    embotellado: EmbotelladoForm,
};

/**
 * Qué formulario se muestra lo decide la URL, no un estado interno:
 *   /nueva-trazabilidad               -> el menú de las tres opciones
 *   /nueva-trazabilidad/viticultura   -> ese formulario
 *
 * Antes la elección vivía en un estado (primero en App.js, después acá) y eso
 * daba dos problemas: al volver a entrar seguía abierto el formulario anterior,
 * y estando adentro de uno, elegir "Nuevo > Trazabilidad" no hacía nada porque
 * la ruta no cambiaba. Con la URL como fuente de verdad se arregla solo, y de
 * paso andan el botón "atrás" del navegador y los links directos.
 */
function TrazabilidadNuevo() {
    const navigate = useNavigate();
    const { tipo } = useParams();

    const FormularioElegido = FORMULARIOS[tipo];

    const opciones = [
        { id: 'viticultura', label: 'Viticultura', Icono: ViticulturaIcon },
        { id: 'vinificacion', label: 'Vinificación', Icono: VinificacionIcon },
        { id: 'embotellado', label: 'Embotellado', Icono: EmbotelladoIcon },
    ];

    const renderForm = () => {
        // Si la URL trae un tipo que no existe, se muestra el menú.
        if (FormularioElegido) {
            return <FormularioElegido onBack={() => navigate('/nueva-trazabilidad')} />;
        }

        return (
            <div className="selection-container">
                <p>¿Qué tipo de código querés generar?</p>
                <div className="button-group" style={{ display: 'flex', gap: '20px' }}>
                    {opciones.map(({ id, label, Icono }) => (
                        <div
                            key={id}
                            className="button-item"
                            onClick={() => navigate(`/nueva-trazabilidad/${id}`)}
                            style={{ cursor: 'pointer', textAlign: 'center' }}
                        >
                            <Icono className="trazabilidad-icon" />
                            <p>{label}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className="Trazabilidad">
            <header className="trazabilidad-header">
                <div className="header-content">
                    <h1>Trazabilidad</h1>
                </div>
            </header>

            <main className="trazabilidad-main-content">
                {renderForm()}
            </main>
        </div>
    );
}

export default TrazabilidadNuevo;
